import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../api/api";
import { getPracticeId } from "../../../../config/practice";


const MdqLink = () => {
  const { patientid, filename } = useParams();
  const [loading, setLoading] = useState(true);
  const [json, setJson] = useState(null);

  const practiseid = getPracticeId();
  const SCREENSHOT_TARGET_ID = "screenshot-ready-container";

  useEffect(() => {
    const fetchHtml = async () => {
      try {
        const response = await api.get(
          `/v1/${practiseid}/pcard/${patientid}/formHistory/${filename}`
        );
        if (response.status === 200) {
          setJson(response.data?.json_data || null);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setTimeout(() => setLoading(false), 300);
      }
    };

    fetchHtml();
  }, [filename]);

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen text-xl font-semibold">
        Loading...
      </div>
    );

  if (!json)
    return (
      <div className="flex items-center justify-center h-screen text-xl text-red-600">
        No Data Found
      </div>
    );

  // ---------------------------------------------------

  const renderYesNo = (key) => (
    <div className="flex space-x-4 mt-2">
      {["Yes", "NO"].map((opt) => (
        <span
          key={opt}
          className={`px-4 py-2 rounded-full text-sm font-sans ${
            json[key] === opt
              ? "bg-blue-600 text-white border border-blue-600"
              : "bg-white border-2 border-gray-300 text-black"
          }`}
        >
          {opt}
        </span>
      ))}
    </div>
  );

  const renderSingleChoice = (key, options) => (
    <div className="flex space-x-4 mt-2">
      {options.map((opt) => (
        <span
          key={opt}
          className={`px-4 py-2 rounded-full text-sm font-sans ${
            json[key] === opt
              ? "bg-blue-600 text-white border border-blue-600"
              : "bg-white border-2 border-gray-300 text-black"
          }`}
        >
          {opt}
        </span>
      ))}
    </div>
  );

  const questions = [
    {
      q: "Has there ever been a period when you were not your usual self and felt unusually good or hyper?",
      key: "qanswer_5_2",
    },
    {
      q: "Were you so irritable that you shouted at people or started fights?",
      key: "qanswer_5_3",
    },
    { q: "Did you feel much more self-confident than usual?", key: "qanswer_5_4" },
    { q: "Did you need far less sleep than usual?", key: "qanswer_5_5" },
    { q: "Were you much more talkative?", key: "qanswer_5_6" },
    { q: "Did thoughts race through your mind?", key: "qanswer_5_7" },
    {
      q: "Were you easily distracted and had trouble concentrating?",
      key: "qanswer_5_8",
    },
    { q: "Did you have much more energy than usual?", key: "qanswer_5_9" },
    { q: "Were you much more active than usual?", key: "qanswer_5_10" },
    {
      q: "Were you more social than usual? (e.g., calling friends at night)",
      key: "qanswer_5_11",
    },
    {
      q: "Did you do anything unusual, excessive, foolish, or risky?",
      key: "qanswer_5_12",
    },
    { q: "Did spending money cause trouble for you?", key: "qanswer_5_13" },
  ];

  // ---------------------------------------------------

  return (
    <>
      {/* Hidden screenshot trigger */}
    

      <div  id={json.patient_name?SCREENSHOT_TARGET_ID:undefined} className="min-h-screen bg-[#f7f7f7] flex justify-center py-10 px-3">
        <div className="bg-white text-start shadow-lg rounded-lg p-6 max-w-4xl w-full">

          <h2 className="text-2xl font-bold mb-4">{json.form_name}</h2>

          {/* Patient Info */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <label className="font-bold text-base">Patient Name</label>
              <p>{json.patient_name}</p>
            </div>
            <div>
              <label className="font-bold text-base">Date</label>
              <p>{json.cdate_5}</p>
            </div>
          </div>

          {/* Instructions */}
          <h3 className="font-bold text-xl mb-4">
            Instructions: Select the answer that best applies to you.
          </h3>

          {/* Questions */}
          {questions.map((q, idx) => (
            <div key={idx} className="mb-4">
              <label className="font-bold text-base">{q.q}</label>
              {renderYesNo(q.key)}
            </div>
          ))}

          {/* Same-period question */}
          <div className="mb-4">
            <label className="font-bold text-base">
              Have several of these happened during the same period of time?
            </label>
            {renderYesNo("qanswer_5_14")}
          </div>

          {/* Severity */}
          <div className="mb-4">
            <label className="font-bold text-base">
              How much of a problem did these cause you (work, family, legal, money, arguments)?
            </label>
            {renderSingleChoice("qanswer_5_15", [
              "No Problem",
              "Minor Problem",
              "Moderate Problem",
              "Serious Problem",
            ])}
          </div>

          {/* Family history */}
          <div className="mb-4">
            <label className="font-bold text-base">
              Any blood relatives diagnosed with bipolar disorder or manic depression?
            </label>
            {renderYesNo("qanswer_5_16")}
          </div>

          {/* Diagnosis */}
          <div className="mb-4">
            <label className="font-bold text-base">
              Has a healthcare professional diagnosed you with bipolar disorder?
            </label>
            {renderYesNo("qanswer_5_17")}
          </div>

        </div>
      </div>
    </>
  );
};

export default MdqLink;
